module.exports = __webpack_public_path__ + "static/img/bg-es.75533353.png";